// extracted by mini-css-extract-plugin
export default {"Label":"gS9ytOYz382DasynNLUv","ChangeButton":"K0XLlcOGTcomrbuURdXw","SaveButton":"ph52tO1l5PyNCkdtChv7"};